







export default {
  name: 'ThumbUpIcon',
  props: {
    color: {
      type: String,
      default: '#000'
    }
  }
}
